import { useEffect, useRef } from 'react'
import { useTrackAnalytics } from '@/hooks/useCMS'
import { useLocation } from 'react-router-dom'
import { usePerformanceOptimization } from '@/hooks/usePerformanceOptimization'
import { useCookies } from '@/hooks/useCookies'

export const OptimizedAnalyticsTracker = () => {
  const location = useLocation()
  const trackAnalytics = useTrackAnalytics()
  const { debounce } = usePerformanceOptimization()
  const lastTracked = useRef<string>('')
  const { cookiePreferences } = useCookies()

  // Débouncer le tracking pour éviter les appels multiples
  const debouncedTrack = debounce(async (pathname: string) => {
    // Ne pas tracker si les cookies analytiques ne sont pas acceptés
    if (!cookiePreferences.analytics) return;
    
    // Éviter les doublons
    if (lastTracked.current === pathname) return
    lastTracked.current = pathname

    const visitorId = localStorage.getItem('visitor_id') || Math.random().toString(36).substr(2, 9)
    localStorage.setItem('visitor_id', visitorId)

    const sessionId = sessionStorage.getItem('session_id') || Math.random().toString(36).substr(2, 9)
    sessionStorage.setItem('session_id', sessionId)

    const detectDeviceType = () => {
      const userAgent = navigator.userAgent
      if (/tablet|ipad|playbook|silk/i.test(userAgent)) return 'tablet'
      if (/mobile|iphone|ipod|android|blackberry|opera|mini|windows\sce|palm|smartphone|iemobile/i.test(userAgent)) return 'mobile'
      return 'desktop'
    }

    try {
      await trackAnalytics.mutateAsync({
        page_slug: pathname,
        visitor_id: visitorId,
        session_id: sessionId,
        user_agent: navigator.userAgent,
        referrer: document.referrer || null,
        device_type: detectDeviceType(),
      })
    } catch (error) {
      console.debug('Analytics tracking failed:', error)
    }
  }, 500)

  useEffect(() => {
    if (cookiePreferences.analytics) {
      debouncedTrack(location.pathname)
    }
  }, [location.pathname, debouncedTrack, cookiePreferences.analytics])

  return null
}
